import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Update active screen tab using provided selected tab index
 * @param {UpdateActiveScreenTabPayload} payload - contains selected tab index
 */
export var updateActiveScreenTab = function updateActiveScreenTab(_ref) {
  var selected = _ref.selected;
  return function (_ref2) {
    var getState = _ref2.getState,
      setState = _ref2.setState;
    var _getState = getState(),
      screenTabs = _getState.screenTabs;
    if (screenTabs) {
      setState({
        screenTabs: screenTabs.map(function (tab, index) {
          return _objectSpread(_objectSpread({}, tab), {}, {
            isActive: index === selected
          });
        })
      });
    }
  };
};